var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 162,
    viewBox: "0 0 273 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577:19298)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M252.699 129.096C251.865 130.674 250.461 131.876 248.772 132.457C247.084 133.038 245.237 132.956 243.607 132.226C241.977 131.496 240.686 130.174 239.996 128.528C239.305 126.882 239.267 125.035 239.889 123.362C240.468 123.742 240.988 124.205 241.431 124.737C242.1 125.553 242.542 126.475 243.315 127.235C244.752 128.644 247.083 129.226 249.14 129.282C250.329 129.289 251.518 129.227 252.699 129.096V129.096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.701 162.003C209.45 162.003 266.803 156.27 266.803 149.198C266.803 142.127 209.45 136.394 138.701 136.394C67.9527 136.394 10.5996 142.127 10.5996 149.198C10.5996 156.27 67.9527 162.003 138.701 162.003Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.8196 27.8654C22.6384 27.1218 22.6473 26.3447 22.8452 25.6055C23.0432 24.8663 23.4239 24.1887 23.9524 23.635L25.5047 25.2844L24.7838 22.9471C25.5977 22.4232 26.557 22.1714 27.5234 22.228C28.4897 22.2847 29.4131 22.6468 30.1602 23.2621C30.9072 23.8774 31.4393 24.7141 31.6796 25.6514C31.9199 26.5887 31.856 27.5781 31.4972 28.4767C31.1383 29.3753 30.503 30.1367 29.683 30.6509C28.863 31.1651 27.9007 31.4055 26.9351 31.3375C25.9694 31.2695 25.0504 30.8965 24.3107 30.2724C23.571 29.6483 23.0488 28.8054 22.8196 27.8654V27.8654Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.754 28.8596C24.7964 28.6738 25.8739 28.6989 26.9063 28.4629C27.9386 28.2269 28.9835 27.657 29.393 26.6804C29.614 26.1532 29.6291 25.5657 29.7848 25.0159C29.9343 24.5025 30.2087 24.0341 30.5836 23.6526C31.0297 24.1249 31.37 24.6868 31.5816 25.301C31.7932 25.9152 31.8713 26.5674 31.8107 27.2142C31.75 27.8609 31.552 28.4873 31.23 29.0514C30.9079 29.6156 30.4691 30.1046 29.9429 30.4858C29.4166 30.867 28.8151 31.1316 28.1785 31.2619C27.5418 31.3923 26.8847 31.3854 26.2509 31.2417C25.6171 31.098 25.0213 30.8208 24.5032 30.4287C23.9852 30.0365 23.5567 29.5384 23.2466 28.9676C23.4149 28.9274 23.5832 28.8897 23.754 28.8596Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.862 0.682962C236.366 0.324351 236.952 0.0980347 237.566 0.024778C238.181 -0.0484786 238.804 0.0336713 239.378 0.26369L238.602 1.92321L240.142 0.682962C240.779 1.13559 241.256 1.77915 241.504 2.52063C241.752 3.2621 241.757 4.06309 241.52 4.80784C241.282 5.55259 240.814 6.20253 240.182 6.66371C239.551 7.1249 238.789 7.37346 238.007 7.37346C237.225 7.37346 236.463 7.1249 235.831 6.66371C235.2 6.20253 234.731 5.55259 234.494 4.80784C234.256 4.06309 234.261 3.2621 234.509 2.52063C234.757 1.77915 235.234 1.13559 235.872 0.682962H235.862Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.396 1.68223C235.848 2.4078 236.149 3.22124 236.637 3.92672C237.124 4.6322 237.865 5.24228 238.721 5.25484C239.181 5.25484 239.628 5.09918 240.085 5.05148C240.513 5.01167 240.944 5.07629 241.341 5.23977C241.121 5.71579 240.801 6.1393 240.404 6.48201C240.006 6.82473 239.54 7.07876 239.037 7.22716C238.533 7.37556 238.004 7.41491 237.484 7.34258C236.964 7.27025 236.466 7.0879 236.022 6.80771C235.579 6.52753 235.2 6.15594 234.911 5.71778C234.623 5.27961 234.431 4.78495 234.349 4.26681C234.267 3.74867 234.296 3.21898 234.435 2.7131C234.574 2.20723 234.819 1.73681 235.155 1.33325C235.243 1.44623 235.323 1.56172 235.396 1.68223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.348 18.7869C251.932 18.3716 252.61 18.1095 253.321 18.0248C254.032 17.9402 254.753 18.0356 255.417 18.3023L254.521 20.223L256.304 18.7844C257.041 19.3094 257.592 20.0549 257.878 20.9133C258.164 21.7718 258.169 22.6988 257.893 23.5605C257.618 24.4222 257.075 25.174 256.344 25.7074C255.613 26.2409 254.731 26.5284 253.826 26.5284C252.921 26.5284 252.039 26.2409 251.308 25.7074C250.577 25.174 250.035 24.4222 249.759 23.5605C249.483 22.6988 249.489 21.7718 249.774 20.9133C250.06 20.0549 250.611 19.3094 251.348 18.7844V18.7869Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M250.808 19.9418C251.333 20.7829 251.682 21.7269 252.248 22.5428C252.813 23.3588 253.667 24.0643 254.659 24.0819C255.194 24.0819 255.709 23.8986 256.241 23.8433C256.738 23.7965 257.24 23.8724 257.701 24.0643C257.445 24.6138 257.074 25.1026 256.615 25.498C256.155 25.8934 255.616 26.1863 255.034 26.3573C254.452 26.5284 253.841 26.5735 253.24 26.4898C252.639 26.4062 252.063 26.1955 251.551 25.872C251.038 25.5484 250.6 25.1194 250.266 24.6134C249.932 24.1074 249.709 23.5361 249.613 22.9375C249.517 22.339 249.55 21.7268 249.709 21.1419C249.869 20.5569 250.151 20.0126 250.537 19.5452C250.632 19.6707 250.723 19.8038 250.808 19.9418Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M247.021 17.5693L246.965 142.671C238.174 142.671 246.965 142.671 238.089 142.716H205.056L204.955 142.676C195.705 142.716 195.979 142.716 189.576 142.676L189.493 142.711H156.39C151.027 142.676 151.85 142.711 149.657 142.716C144.175 142.716 147.26 142.716 144.175 142.716C141.089 142.716 141.16 142.711 135.678 142.716C132.091 142.711 135.952 142.726 132.091 142.711H98.9625L98.8796 142.676C89.0814 142.716 89.6296 142.716 83.4998 142.676L83.3994 142.716H50.3717C44.725 140.419 39.6114 136.985 35.3486 132.628V17.5693H247.021Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.021 12.6761V18.0714H35.3462V12.6761C35.3459 12.4327 35.3936 12.1916 35.4866 11.9667C35.5797 11.7417 35.7162 11.5373 35.8884 11.3652C36.0606 11.1931 36.2651 11.0566 36.4901 10.9636C36.7152 10.8706 36.9564 10.8229 37.1999 10.8233H245.162C245.406 10.8223 245.647 10.8695 245.873 10.9622C246.099 11.0549 246.304 11.1912 246.477 11.3634C246.649 11.5356 246.786 11.7402 246.88 11.9655C246.973 12.1908 247.021 12.4323 247.021 12.6761V12.6761Z",
    fill: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.702 15.2597C39.1806 15.2597 39.5686 14.8719 39.5686 14.3935C39.5686 13.9151 39.1806 13.5273 38.702 13.5273C38.2234 13.5273 37.8354 13.9151 37.8354 14.3935C37.8354 14.8719 38.2234 15.2597 38.702 15.2597Z",
    fill: "#FA5959"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M41.0829 15.2597C41.5615 15.2597 41.9494 14.8719 41.9494 14.3935C41.9494 13.9151 41.5615 13.5273 41.0829 13.5273C40.6043 13.5273 40.2163 13.9151 40.2163 14.3935C40.2163 14.8719 40.6043 15.2597 41.0829 15.2597Z",
    fill: "#FED253"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.4618 15.2597C43.9404 15.2597 44.3284 14.8719 44.3284 14.3935C44.3284 13.9151 43.9404 13.5273 43.4618 13.5273C42.9832 13.5273 42.5952 13.9151 42.5952 14.3935C42.5952 14.8719 42.9832 15.2597 43.4618 15.2597Z",
    fill: "#8CCF4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0965 18.0715V142.967C63.0965 142.967 51.7934 142.922 35.3486 142.671V18.0715H63.0965Z",
    fill: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5977 18.0715V143.173C91.4922 143.251 81.4902 143.058 81.0481 143.218H63.8423V18.0715H91.5977Z",
    fill: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2682 24.1697H39.1738V26.6803H59.2682V24.1697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2682 29.9441H39.1738V32.4547H59.2682V29.9441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2682 35.7185H39.1738V38.2291H59.2682V35.7185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2682 41.4929H39.1738V44.0035H59.2682V41.4929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2682 47.2673H39.1738V49.7779H59.2682V47.2673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 64.3396H39.2344V66.8502H59.3288V64.3396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 70.114H39.2344V72.6246H59.3288V70.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 75.8884H39.2344V78.399H59.3288V75.8884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 52.8074H39.2344V55.318H59.3288V52.8074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 58.5818H39.2344V61.0924H59.3288V58.5818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 64.3562H39.2344V66.8668H59.3288V64.3562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 81.6628H39.2344V84.1735H59.3288V81.6628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 87.4373H39.2344V89.9479H59.3288V87.4373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 93.1951H39.2344V95.7057H59.3288V93.1951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3288 98.9695H39.2344V101.48H59.3288V98.9695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3864 104.509H39.292V107.02H59.3864V104.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3864 110.284H39.292V112.794H59.3864V110.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3864 116.058H39.292V118.569H59.3864V116.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3864 121.833H39.292V124.343H59.3864V121.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3864 127.607H39.292V130.118H59.3864V127.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 19.1484H70.3809V21.6591H72.8927V19.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 19.1484H73.395V21.6591H75.9068V19.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 19.1484H76.4092V21.6591H78.921V19.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 19.1484H79.4233V21.6591H81.9351V19.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 19.1484H82.4375V21.6591H84.9493V19.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 29.6931H70.3809V32.2037H72.8927V29.6931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 29.6931H73.395V32.2037H75.9068V29.6931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 29.6931H76.4092V32.2037H78.921V29.6931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 29.6931H79.4233V32.2037H81.9351V29.6931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 29.6931H82.4375V32.2037H84.9493V29.6931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 40.2375H70.3809V42.7482H72.8927V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 40.2375H73.395V42.7482H75.9068V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 40.2375H76.4092V42.7482H78.921V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 40.2375H79.4233V42.7482H81.9351V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 40.2375H82.4375V42.7482H84.9493V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 50.7822H70.3809V53.2928H72.8927V50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 50.7822H73.395V53.2928H75.9068V50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 50.7822H76.4092V53.2928H78.921V50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 50.7822H79.4233V53.2928H81.9351V50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 50.7822H82.4375V53.2928H84.9493V50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 61.3269H70.3809V63.8375H72.8927V61.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 61.3269H73.395V63.8375H75.9068V61.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 61.3269H76.4092V63.8375H78.921V61.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 61.3269H79.4233V63.8375H81.9351V61.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 61.3269H82.4375V63.8375H84.9493V61.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 71.8713H70.3809V74.382H72.8927V71.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 71.8713H73.395V74.382H75.9068V71.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 71.8713H76.4092V74.382H78.921V71.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 71.8713H79.4233V74.382H81.9351V71.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 71.8713H82.4375V74.382H84.9493V71.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 82.416H70.3809V84.9267H72.8927V82.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 82.416H73.395V84.9267H75.9068V82.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 82.416H76.4092V84.9267H78.921V82.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 82.416H79.4233V84.9267H81.9351V82.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 82.416H82.4375V84.9267H84.9493V82.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 92.9607H70.3809V95.4713H72.8927V92.9607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 92.9607H73.395V95.4713H75.9068V92.9607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 92.9607H76.4092V95.4713H78.921V92.9607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 92.9607H79.4233V95.4713H81.9351V92.9607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 92.9607H82.4375V95.4713H84.9493V92.9607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 103.505H70.3809V106.016H72.8927V103.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 103.505H73.395V106.016H75.9068V103.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 103.505H76.4092V106.016H78.921V103.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 103.505H79.4233V106.016H81.9351V103.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 103.505H82.4375V106.016H84.9493V103.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 114.05H70.3809V116.56H72.8927V114.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 114.05H73.395V116.56H75.9068V114.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 114.05H76.4092V116.56H78.921V114.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 114.05H79.4233V116.56H81.9351V114.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 114.05H82.4375V116.56H84.9493V114.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 124.594H70.3809V127.105H72.8927V124.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 124.594H73.395V127.105H75.9068V124.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 124.594H76.4092V127.105H78.921V124.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 124.594H79.4233V127.105H81.9351V124.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 124.594H82.4375V127.105H84.9493V124.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 135.139H70.3809V137.65H72.8927V135.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9068 135.139H73.395V137.65H75.9068V135.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.921 135.139H76.4092V137.65H78.921V135.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9351 135.139H79.4233V137.65H81.9351V135.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 135.139H82.4375V137.65H84.9493V135.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.2563 146.929C57.2563 146.929 58.2234 148.166 57.9747 148.867C57.7261 149.567 57.2563 146.929 57.2563 146.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.0845 56.6094C61.1087 56.6048 61.1337 56.6052 61.1578 56.6103C61.182 56.6155 61.2049 56.6254 61.2251 56.6395L61.0845 56.6094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 80.5,
    r: 54,
    stroke: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.529,
    cy: 79.0614,
    r: 43.5324,
    stroke: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.324,
    cy: 79.2668,
    r: 31.8315,
    stroke: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.044 79.2668C195.044 90.2689 186.08 99.1921 175.016 99.1921C163.953 99.1921 154.988 90.2689 154.988 79.2668C154.988 68.2648 163.953 59.3416 175.016 59.3416C186.08 59.3416 195.044 68.2648 195.044 79.2668Z",
    stroke: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.883,
    cy: 60.7385,
    rx: 3.31477,
    ry: 3.32057,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.883,
    cy: 60.7385,
    rx: 3.31477,
    ry: 3.32057,
    fill: "url(#paint0_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.883,
    cy: 60.7385,
    rx: 3.31477,
    ry: 3.32057,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.883,
    cy: 60.7385,
    rx: 3.31477,
    ry: 3.32057,
    fill: "url(#paint1_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.659,
    cy: 43.4087,
    rx: 3.31476,
    ry: 3.32057,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.659,
    cy: 43.4087,
    rx: 3.31476,
    ry: 3.32057,
    fill: "url(#paint2_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.659,
    cy: 43.4087,
    rx: 3.31476,
    ry: 3.32057,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.659,
    cy: 43.4087,
    rx: 3.31476,
    ry: 3.32057,
    fill: "url(#paint3_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.797,
    cy: 101.619,
    rx: 3.31476,
    ry: 3.32056,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.797,
    cy: 101.619,
    rx: 3.31476,
    ry: 3.32056,
    fill: "url(#paint4_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.797,
    cy: 101.619,
    rx: 3.31476,
    ry: 3.32056,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.797,
    cy: 101.619,
    rx: 3.31476,
    ry: 3.32056,
    fill: "url(#paint5_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.773,
    cy: 69.2188,
    rx: 5.50753,
    ry: 5.51717,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.773,
    cy: 69.2188,
    rx: 5.50753,
    ry: 5.51717,
    fill: "url(#paint6_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.773,
    cy: 69.2188,
    rx: 5.50753,
    ry: 5.51717,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.773,
    cy: 69.2188,
    rx: 5.50753,
    ry: 5.51717,
    fill: "url(#paint7_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.735,
    cy: 48.2654,
    rx: 3.31476,
    ry: 3.32056,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.735,
    cy: 48.2654,
    rx: 3.31476,
    ry: 3.32056,
    fill: "url(#paint8_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.735,
    cy: 48.2654,
    rx: 3.31476,
    ry: 3.32056,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.735,
    cy: 48.2654,
    rx: 3.31476,
    ry: 3.32056,
    fill: "url(#paint9_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.544,
    cy: 36.7594,
    rx: 7.39296,
    ry: 7.4059,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.544,
    cy: 36.7594,
    rx: 7.39296,
    ry: 7.4059,
    fill: "url(#paint10_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.696,
    cy: 85.378,
    rx: 7.94879,
    ry: 7.96271,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.696,
    cy: 85.378,
    rx: 7.94879,
    ry: 7.96271,
    fill: "url(#paint11_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.545,
    cy: 120.539,
    rx: 4.65965,
    ry: 4.6678,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.545,
    cy: 120.539,
    rx: 4.65965,
    ry: 4.6678,
    fill: "url(#paint12_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.75,
    cy: 102.966,
    rx: 3.01508,
    ry: 3.02034,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.75,
    cy: 102.966,
    rx: 3.01508,
    ry: 3.02034,
    fill: "url(#paint13_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.515,
    cy: 83.7457,
    rx: 3.01506,
    ry: 3.02034,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.515,
    cy: 83.7457,
    rx: 3.01506,
    ry: 3.02034,
    fill: "url(#paint14_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.551,
    cy: 128.776,
    rx: 6.8524,
    ry: 6.86442,
    fill: "#3A53FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.551,
    cy: 128.776,
    rx: 6.8524,
    ry: 6.86442,
    fill: "url(#paint15_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.8142 32.6428C62.4694 32.6428 66.2432 36.8351 66.2432 42.0066V48.577L63.8646 66.1729L63.0558 46.1426L64.2245 62.0543L50.3725 48.577L48.7893 67.5458L44.6779 68.0949L48.1147 43.4181C48.1147 37.4671 52.4573 32.6428 57.8142 32.6428Z",
    fill: "url(#paint16_linear_6577:19298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.751 131.158L53.8964 141.515L49.2304 143.951L52.882 131.158H57.751Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4497 131.97L30.5666 143.951L27.5236 142.124L31.9865 129.939L36.4497 131.97Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1713 46.6784C56.0341 46.6784 53.4909 44.1326 53.4909 40.9923C53.4909 37.8519 56.0341 35.3062 59.1713 35.3062C62.3084 35.3062 64.8516 37.8519 64.8516 40.9923C64.8516 44.1326 62.3084 46.6784 59.1713 46.6784Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9824 45.4599C59.9824 45.4599 57.9537 50.7399 59.171 52.1614C60.3882 53.5829 51.462 49.9276 51.462 49.9276C51.462 49.9276 55.3165 45.2568 55.1136 43.2261L59.9824 45.4599Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8818 49.5215L49.8388 48.9123L46.7958 45.257C46.7958 45.257 45.3757 40.1801 43.5499 38.7585V38.1493C43.5499 38.1493 52.8819 32.0571 55.722 32.2601C55.722 32.2601 65.2568 35.1032 63.431 32.2601C62.9175 31.4605 62.0349 30.8215 61.0315 30.3161C59.5901 29.6063 58.0189 29.1991 56.4146 29.1196C54.8102 29.0402 53.2065 29.2901 51.7022 29.854L38.4782 34.697C38.1823 35.411 38.0472 36.1814 38.0822 36.9535C38.1173 37.7256 38.3217 38.4806 38.681 39.1647C39.8983 41.6016 44.1585 54.1923 44.1585 54.1923C45.1638 56.2355 46.0445 58.3378 46.7958 60.4876C47.8101 63.5337 48.6216 65.5645 48.6216 65.5645L65.8654 65.3614L64.4454 59.0661C64.4454 59.0661 65.8655 56.4261 67.8941 56.223C67.8941 56.223 82.5007 50.5369 83.1093 47.0846C83.1093 47.0846 83.3122 45.8662 82.5007 45.257C81.6892 44.6477 72.5601 34.697 72.5601 34.697C72.5601 34.697 68.5027 29.4171 66.474 31.0417C64.4454 32.6663 70.1257 36.7278 70.1257 36.7278C70.1257 36.7278 76.0089 45.6631 76.8204 46.2723C76.8204 46.2723 71.14 49.7246 69.5171 50.1308C67.8941 50.5369 64.0396 50.1308 62.2138 51.7554C61.4022 51.9798 60.5542 52.0415 59.7187 51.937C58.8831 51.8324 58.0764 51.5637 57.345 51.1461C54.9105 49.7246 52.8818 49.5215 52.8818 49.5215Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7127,
    cy: 25.2867,
    rx: 7.15211,
    ry: 7.16463,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7127,
    cy: 25.2867,
    rx: 7.15211,
    ry: 7.16463,
    fill: "url(#paint17_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dii_6577:19298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7127,
    cy: 25.2867,
    rx: 7.15211,
    ry: 7.16463,
    fill: "#0099F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7127,
    cy: 25.2867,
    rx: 7.15211,
    ry: 7.16463,
    fill: "url(#paint18_radial_6577:19298)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.4026 50.943L64.4456 59.066C64.4456 59.066 67.0829 61.5029 66.0686 67.189C66.0686 67.189 65.6628 72.469 66.88 74.0936C68.0973 75.7182 84.9354 94.1981 68.9087 133.189C68.9087 133.189 58.1567 131.158 50.042 134.61C41.9272 138.062 28.5379 130.955 28.5379 130.955L49.6362 78.9674C49.6362 78.9674 50.2448 68.2044 46.796 63.3306L49.0276 61.5029C49.0276 61.5029 51.6649 55.0045 51.2592 52.9738C51.2592 52.9738 50.4477 48.9123 50.042 48.5061H51.6649L53.8965 53.7861C53.8965 53.7861 57.5481 60.6906 60.5911 60.0814C63.6341 59.4722 61.1997 55.2076 61.1997 55.2076L60.1854 51.1461L61.4026 50.943Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2308 142.124C49.2308 142.124 53.8393 140.237 54.1723 140.774C54.5054 141.312 56.1284 144.561 56.1284 144.561C56.1284 144.561 62.4173 151.059 57.3456 151.872C52.2738 152.684 51.6652 149.841 51.6652 149.841C51.6652 149.841 51.4624 149.638 50.6509 149.638C49.8394 149.638 46.5935 148.419 46.7964 147.81C46.9992 147.201 49.2308 142.124 49.2308 142.124Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3207 140.702C27.3207 140.702 31.581 141.718 31.7839 142.53C31.9867 143.342 33.4068 148.825 32.1896 149.232C30.9724 149.638 29.1466 150.247 28.5379 150.044C27.9293 149.841 26.5093 152.684 23.4662 152.075C20.4232 151.465 19.0031 151.059 19.206 150.856C19.4089 150.653 20.2203 147.607 22.6548 146.388C25.0892 145.17 27.3207 140.702 27.3207 140.702Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4183 35.2224C55.8239 34.6772 56.3495 34.2328 56.9544 33.9239C57.5593 33.6149 58.2272 33.4495 58.9063 33.4407H59.0717C62.2624 33.4407 65.5093 37.0723 65.5093 40.6374L63.0424 46.9527L63.6072 38.5804L60.3014 35.9696L58.3828 36.7934L56.4819 38.783L54.9516 42.0103L55.3674 39.896C54.7853 42.7897 52.0165 56.4149 54.2713 59.3086L55.3674 61.7798H50.904L48.5153 64.8002L50.904 48.5772L50.1071 43.4575C50.1071 39.6233 52.3326 36.372 55.4183 35.2224Z",
    fill: "url(#paint19_linear_6577:19298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.742 142.636C247.234 139.874 245.541 136.495 243.597 134.032C241.653 131.569 239.282 129.011 239.327 125.875C239.4 121.356 244.185 118.707 248.01 116.317C250.843 114.543 253.457 112.44 255.797 110.053C256.734 109.094 257.643 108.07 258.19 106.847C258.982 105.089 258.959 103.081 258.909 101.15C258.741 94.7181 258.424 88.2926 257.957 81.8738",
    stroke: "#3F3D56",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.241 81.5223C265.185 80.345 264.833 79.2008 264.219 78.1948C263.604 77.1888 262.747 76.3534 261.725 75.7655L260.15 78.8786L260.197 75.1127C258.767 74.6917 257.24 74.736 255.837 75.239C254.433 75.7421 253.226 76.6779 252.389 77.9114C251.553 79.1449 251.13 80.6122 251.182 82.1015C251.234 83.5908 251.758 85.0251 252.679 86.1973C253.6 87.3694 254.869 88.2187 256.304 88.6227C257.74 89.0266 259.266 88.9643 260.663 88.4446C262.061 87.9249 263.257 86.9749 264.079 85.7315C264.9 84.4882 265.306 83.0159 265.236 81.5273L265.241 81.5223Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.699 129.096C251.958 130.528 250.747 131.663 249.269 132.308C247.791 132.954 246.136 133.073 244.581 132.644C243.025 132.215 241.665 131.264 240.728 129.952C239.791 128.639 239.333 127.045 239.432 125.435C239.531 123.826 240.181 122.299 241.273 121.112C242.364 119.924 243.831 119.148 245.427 118.913C247.023 118.678 248.651 118.998 250.039 119.82C251.426 120.643 252.489 121.917 253.049 123.429L248.658 127.002L253.488 125.882C253.488 127.001 253.217 128.104 252.699 129.096V129.096Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.228 115.448C248.306 115.491 247.384 115.353 246.515 115.04C245.646 114.727 244.847 114.246 244.164 113.624C243.481 113.003 242.927 112.253 242.534 111.417C242.141 110.582 241.917 109.677 241.874 108.755C241.819 107.655 242.028 106.558 242.482 105.554C242.903 104.613 243.527 103.777 244.308 103.104C245.09 102.431 246.01 101.938 247.003 101.66L246.968 104.557L248.56 101.406H248.578C249.5 101.363 250.422 101.502 251.291 101.815C252.16 102.128 252.959 102.609 253.642 103.231C254.325 103.852 254.879 104.602 255.272 105.437C255.665 106.273 255.889 107.178 255.932 108.1C255.975 109.022 255.837 109.943 255.523 110.812C255.21 111.68 254.729 112.479 254.107 113.161C253.485 113.844 252.735 114.398 251.899 114.79C251.063 115.183 250.158 115.408 249.236 115.451L249.228 115.448Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.298 104.098C265.211 104.149 264.126 103.947 263.129 103.507C262.133 103.068 261.252 102.404 260.556 101.566C259.861 100.728 259.369 99.7409 259.12 98.6812C258.872 97.6214 258.873 96.5183 259.123 95.459C259.374 94.3996 259.867 93.4128 260.564 92.5765C261.261 91.7401 262.143 91.0769 263.14 90.6392C264.137 90.2015 265.222 90.0013 266.31 90.0542C267.398 90.1072 268.458 90.4119 269.408 90.9444L268.152 94.3463L270.709 91.8935C272.075 93.1485 272.888 94.8936 272.97 96.7465C273.003 97.3969 272.943 98.0486 272.791 98.6821C272.443 100.166 271.621 101.497 270.45 102.474C269.279 103.451 267.822 104.021 266.298 104.098V104.098Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M264.294 83.3951C262.672 83.5734 261.094 84.078 259.464 84.181C257.834 84.2839 256.048 83.8897 255.016 82.6244C254.461 81.944 254.184 81.0803 253.715 80.3372C253.27 79.6445 252.662 79.072 251.944 78.6702C251.492 79.5611 251.235 80.538 251.191 81.5358C251.147 82.5336 251.316 83.5295 251.686 84.4569C252.057 85.3844 252.622 86.2222 253.342 86.9146C254.062 87.607 254.922 88.138 255.863 88.4723C256.805 88.8066 257.807 88.9365 258.803 88.8533C259.799 88.7701 260.765 88.4758 261.638 87.99C262.511 87.5041 263.271 86.8379 263.866 86.0356C264.461 85.2334 264.879 84.3135 265.09 83.3374C264.824 83.3474 264.558 83.3675 264.294 83.3951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M266.299 104.098C265.086 104.155 263.88 103.897 262.796 103.35C261.713 102.803 260.789 101.985 260.116 100.975C259.443 99.966 259.042 98.7996 258.953 97.5895C258.865 96.3795 259.091 95.1671 259.61 94.0703C260.168 94.4463 260.649 94.9272 261.024 95.4863C261.526 96.2395 261.828 97.1157 262.418 97.8086C263.511 99.0966 265.382 99.5183 267.08 99.438C268.778 99.3577 270.415 98.8806 272.103 98.725C272.337 98.7049 272.576 98.6873 272.812 98.6823C272.462 100.17 271.638 101.503 270.463 102.48C269.287 103.457 267.826 104.025 266.299 104.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M249.228 115.448C248.306 115.492 247.384 115.353 246.515 115.04C245.646 114.727 244.847 114.246 244.164 113.624C243.481 113.003 242.927 112.253 242.534 111.417C242.141 110.582 241.917 109.677 241.874 108.755C241.819 107.655 242.028 106.558 242.482 105.554C243.06 105.936 243.564 106.42 243.969 106.982C244.514 107.753 244.855 108.64 245.493 109.353C246.679 110.673 248.673 111.138 250.472 111.095C252.215 111.057 253.89 110.63 255.621 110.497C255.194 111.88 254.352 113.097 253.208 113.983C252.064 114.869 250.674 115.381 249.228 115.448V115.448Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_6577:19298",
    x: 170.568,
    y: 47.418,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_6577:19298",
    x: 170.568,
    y: 47.418,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_6577:19298",
    x: 204.344,
    y: 30.0881,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_6577:19298",
    x: 204.344,
    y: 30.0881,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_6577:19298",
    x: 177.482,
    y: 88.2983,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii_6577:19298",
    x: 177.482,
    y: 88.2983,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dii_6577:19298",
    x: 152.265,
    y: 53.7017,
    width: 31.0151,
    height: 37.7844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dii_6577:19298",
    x: 152.265,
    y: 53.7017,
    width: 31.0151,
    height: 37.7844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dii_6577:19298",
    x: 154.42,
    y: 34.9448,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dii_6577:19298",
    x: 154.42,
    y: 34.9448,
    width: 26.6294,
    height: 33.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dii_6577:19298",
    x: 114.401,
    y: 12.6035,
    width: 48.2861,
    height: 48.3118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dii_6577:19298",
    x: 150.997,
    y: 60.6653,
    width: 49.3975,
    height: 49.4255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dii_6577:19298",
    x: 124.136,
    y: 99.1211,
    width: 42.8193,
    height: 42.8357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dii_6577:19298",
    x: 184.985,
    y: 83.1958,
    width: 39.5303,
    height: 39.5408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_dii_6577:19298",
    x: 119.75,
    y: 63.9753,
    width: 39.5303,
    height: 39.5408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dii_6577:19298",
    x: 195.949,
    y: 105.162,
    width: 47.2046,
    height: 47.2288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.32549 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_dii_6577:19298",
    x: 47.5605,
    y: 8.12207,
    width: 34.3042,
    height: 41.0793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dii_6577:19298",
    x: 47.5605,
    y: 8.12207,
    width: 34.3042,
    height: 41.0793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.458824 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6577:19298",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.375,
    dy: 16.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.470588 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6577:19298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6577:19298",
    result: "effect3_innerShadow_6577:19298"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.235 59.49) rotate(110.94) scale(6.82633 6.81746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.235 59.49) rotate(110.94) scale(6.82633 6.81746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.011 42.1602) rotate(110.94) scale(6.82633 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.011 42.1602) rotate(110.94) scale(6.82633 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.149 100.37) rotate(110.94) scale(6.82631 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.149 100.37) rotate(110.94) scale(6.82631 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.02 67.1444) rotate(110.94) scale(11.342 11.3273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.02 67.1444) rotate(110.94) scale(11.342 11.3273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.087 47.0169) rotate(110.94) scale(6.82632 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.087 47.0169) rotate(110.94) scale(6.82632 6.81744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.561 33.9748) rotate(110.94) scale(15.2248 15.2051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.939 82.384) rotate(110.94) scale(16.3695 16.3482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.447 118.784) rotate(110.94) scale(9.59594 9.58348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.98 101.83) rotate(110.94) scale(6.20913 6.20108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.745 82.61) rotate(110.94) scale(6.20913 6.20106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.347 126.195) rotate(110.94) scale(14.1117 14.0933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A53FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6577:19298",
    x1: 55.4605,
    y1: 32.6428,
    x2: 55.4605,
    y2: 68.0949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B0707"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6307 22.5928) rotate(110.94) scale(14.7289 14.7097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_6577:19298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6307 22.5928) rotate(110.94) scale(14.7289 14.7097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F278A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6577:19298",
    x1: 57.0123,
    y1: 33.4407,
    x2: 57.0123,
    y2: 64.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B0707"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577:19298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 162,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix);
export default __webpack_public_path__ + "static/media/matrix.27687db2.svg";
export { ForwardRef as ReactComponent };